<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>穩定供電責任</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTit">和平電廠責任 日以繼夜守護北東電網</div>
        <p class="highlight">2017 年尼莎颱風吹倒了和平電廠電塔……</p>
        <p>2017 年 7 月 29 日中度颱風尼莎吹倒花蓮和平 72 號高壓電塔，導致電力無法外送，颱風離境後又遇上高溫，用電量攀升，臺北都會區面臨限電危機，搶修期間全台公部門下午 1 點到 3 點的用電尖峰時段，空調溫度必須調整到 28℃ 以上，以緩解當時電力供應不足的窘境。</p>
        <p>遭到吹垮的第 72 號電塔，位於蘇澳鎮的東澳區域，電塔高度 75 公尺（約 25 層樓），其前後電塔也因超高壓電線連結拉扯，整排電塔歪斜，和平電力團隊在烈日下展現堅毅的團隊精神，不畏艱難面對、解決問題。</p>
        <p>電塔倒塌及修復在炎熱的 7、8 月，高聳電塔要修復任務艱鉅，為了盡快恢復電力供應，那段時間連父親節假期都不得閒，原本預估最快也要 15 天的修復期，但和平電力團隊只花了 13 天就讓電力恢復供應，這就是和電的使命！</p>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer1-1">
              <div class="imgTit">台泥董事長張安平親赴 72 號倒塌電塔勘查</div>
            </div>
          </div>
          <div class="right">
            <div class="imgContainer1-2"></div>
          </div>          
        </div>
        <p class="highlight">2024 年天搖地動的一分鐘</p>
        <p>2024 年 4 月 3 日早上 7 點 58 分，花蓮近海發生芮氏規模 7.2 的逆斷層地震，造成台灣長達近一分鐘的劇烈搖晃，是 921 震後 25 年來最大的一次，第一時間全台8 部發電機組跳脫，導致電力供應減少 8％，位於當天地震震度最強區域的和平電廠亦遭受重創，鍋爐爐管破裂，成為了受災最嚴重的電廠之一。</p>
        <p>當時和平電廠跳機先以輔機復電，修復的工程十分繁複，因為每一鍋爐內的金屬管密密麻麻，長度加起來可以繞台灣一圈，加上鍋爐內高溫 1,200℃，得等到降溫後，工作人員才能進去檢查，搶修期間餘震不斷，使得電廠爐內狹窄空間及高處懸吊搶修作業受阻，當時廠內 2 部機組，2 號機原本就規劃在 4 月 4 日時開始進行大修，因此我們率先全力檢修 1 號機，上下一心的共同信念讓檢修工作花了不到兩周即完成，4 月 17 日和平電廠一號機組恢復滿載供電。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="gallery">
        <div class="left">
        </div>
        <div class="middle">
          <div class="sectTit">0403 強震後<br>和平電力工作人員日夜搶修</div>                          
          <div class="desp">
            <p>0403 花蓮強震就發生在清明連假前一天！</p>
            <p>為了盡快恢復電力供應，</p>
            <p>許多同仁放棄了跟家人出遊或掃墓的安排，</p>
            <p>鍋爐組檢修同事甚至直接住在廠內，</p>
            <p>只為了盡快找出鍋爐破損點，</p>
            <p>這就是和電人的使命！</p>
          </div>
        </div>
        <div class="right">
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'AboutStblePower',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 1.01);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-2") as HTMLElement, 0.685);
    new ImgContainerAutoResize(document.querySelector(".sect2 .gallery .left") as HTMLElement, 1.6);
    new ImgContainerAutoResize(document.querySelector(".sect2 .gallery .middle") as HTMLElement, 1.2);
    new ImgContainerAutoResize(document.querySelector(".sect2 .gallery .right") as HTMLElement, 1.6);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/aboutStablePower/kv.webp");
  background-position: center 35%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 .highlight {
  letter-spacing: 1px;
  font-size: 22px;
  color: #E99776;
}

.sect1 p {
  line-height: 2em;
  letter-spacing: 1px;
}

.sect1 .gallery {
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;
}

.sect1 .gallery .left {
  flex: 0 0 40%;
}

.sect1 .gallery .left .imgContainer1-1 {
  position: relative;
  overflow: hidden;
  background: url(../../assets/aboutStablePower/pic1_01.jpg);
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.sect1 .gallery .left .imgContainer1-1 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect1 .gallery .right {
  flex: 0 0 59%;
}

.sect1 .gallery .right .imgContainer1-2 {
  background: url(../../assets/aboutStablePower/pic1_02.jpg) center no-repeat;
  background-size: cover;
}

.sect2 .ctx {
  /* width: 100%; */
}

.sect2 .sectTit {
  margin: 0 0 20px;
  text-align: center;
  font-size: 40px;
  color: #fff;
}

.sect2 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect2 .gallery .left {
  flex: 0 0 30%;
  background: url(../../assets/aboutStablePower/pic2_01.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.sect2 .gallery .middle {
  flex: 0 0 40%;
  position: relative;
  text-align: center;
  color: #fff;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.7) 100%), url(../../assets/aboutStablePower/pic2_02.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.sect2 .gallery .middle .sectTit {
  margin: 50px 0 0;
  line-height: 1.6em;
  font-size: 40px;
  text-shadow: 5px 5px 3px #000000;
}

.sect2 .gallery .middle .desp {
  width: 100%;
  position: absolute;
  bottom: 50px;
  line-height: 2em;
  letter-spacing: 1px;
}

.sect2 .gallery .right {
  flex: 0 0 30%;
  background: url(../../assets/aboutStablePower/pic2_03.jpg);
  background-position: left center;
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

    .sect2 .gallery .left {
    flex: 0 0 50%;
  }

  .sect2 .gallery .middle {
    flex: 0 0 100%;
    order: 3;
  }

  .sect2 .gallery .right {
    flex: 0 0 50%;
    order: 2;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .gallery .left {
    flex: 0 0 100%;
  }

  .sect1 .gallery .right {
    flex: 0 0 100%;
    margin: 5px 0 0;
  }

  .sect2 .gallery .left {
    flex: 0 0 100%;
  }

  .sect2 .gallery .middle {
    flex: 0 0 100%;
  }

  .sect2 .gallery .middle .sectTit {
    margin: 20px 0 0;
    line-height: 1.2em;
    font-size: 28px;
  }

  .sect2 .gallery .middle .desp {
    bottom: 20px;
    line-height: 1.1em;
  }

  .sect2 .gallery .right {
    flex: 0 0 100%;
  }
}
</style>
